import { atom, atomEffect } from '@exodus/headless-ui';
import { fromWalletAccountAtom, toWalletAccountAtom } from '../atoms/index.js';
const activeWalletAccountAtom = atom((get, { selectors }) => {
    const getWalletAccount = get(selectors.walletAccounts.get);
    const activeWalletAccountName = get(selectors.walletAccounts.active);
    return getWalletAccount(activeWalletAccountName);
});
const activeWalletAccountEffect = atomEffect((get, set) => {
    const activeWalletAccount = get(activeWalletAccountAtom);
    set(fromWalletAccountAtom, activeWalletAccount);
    set(toWalletAccountAtom, activeWalletAccount);
});
export default activeWalletAccountEffect;
